import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Header from './Header';

function VerificationPage() {

    const navigate = useNavigate();
    const { guid } = useParams();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [lastName, setLastName] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const response = await axios.get(
                `/proxy/api/1.0/integration/engage/e-docs/${guid}`,
                {
                    params: {
                        emailAddress: email,
                        lastName: lastName,
                    },
                }
            );

            navigate('/home', { state: response.data });

        } catch (err) {
            alert(err?.response?.data?.msg || "Request failed");
        } finally {
            setLoading(false);
        }
    };

    if(loading) return <p>Loading...</p>;

    return (
        <div id='content'>
            <Header />
            <div id='instructions'>Please Verify Your Identity</div>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Email Address:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Last Name:</label>
                    <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Submit</button>
            </form>
        </div>
    )
}

export default VerificationPage;
